import { X } from "lucide-react";
import { useEffect, useState } from "react";
import ContentTypeModal from "../modals/ContentTypeModal";
import FollowersModal from "../modals/FollowersModal";
import LocationModal from "../modals/LocationModal";
import GenderModal from "../modals/GenderModal";
import PriceModal from "../modals/PriceModal";
import PremiumModal from "../modals/PremiumModal";
import LanguageModal from "../modals/LanguageModal";
import AgeModal from "../modals/AgeModal";
import EthnicityModal from "../modals/EthnicityModal";
import VerifiedModal from "../modals/VerifiedModal";


//Instead of hardcoding conditions everywhere, define a list of modals and their positions.



const FilterModal = ({ type, buttonRef, ...props }) => {
  const MODALS = {
    contentType: ContentTypeModal,
    followers: FollowersModal,
    location: LocationModal,
    gender: GenderModal,
    price: PriceModal,
    language: LanguageModal,
    age: AgeModal,
    ethnicity: EthnicityModal,
    verified: VerifiedModal,
    premium: PremiumModal
  };
  const MODAL_POSITIONS = ["gender", "age", "price", "contentType", "ethnicity", "followers", "location", "language", "verified"];
  // Hooks must be called unconditionally at the top level
  const [position, setPosition] = useState({ top: 0, left: 0 });

  useEffect(() => {
    if (MODAL_POSITIONS.includes(type) && buttonRef?.current) {
      const updatePosition = () => {
        // Find the button element inside the ref container
        const buttonElement = buttonRef.current.querySelector('button');
        const elementToUse = buttonElement || buttonRef.current;
        const rect = elementToUse.getBoundingClientRect();
        setPosition({
          top: rect.bottom + 8, // 8px gap below button
          left: rect.left
        });
      };
      updatePosition();
      window.addEventListener("scroll", updatePosition, true);
      window.addEventListener("resize", updatePosition);
      return () => {
        window.removeEventListener("scroll", updatePosition, true);
        window.removeEventListener("resize", updatePosition);
      };
    }
  }, [type, buttonRef]);

  const Component = MODALS[type];
  if (!Component) return null;

  // Gender modal positioned below button
  if (MODAL_POSITIONS.includes(type) && buttonRef) {
    return (
      <>
        {/* Overlay for clicking outside */}
        <div 
          className="fixed inset-0 z-40" 
          onClick={props.onClose}
        />
        {/* Modal positioned below button */}
        <div 
          className="fixed z-40 bg-white rounded-lg shadow-lg p-2 md:p-4 w-full md:w-64"
          style={{
            top: `${position.top}px`,
            left: `${position.left}px`
          }}
        >
          <Component {...props} />
        </div>
      </>
    );
  }

  // Other modals centered with overlay
  return (
    <div className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center p-4 sm:p-6">
      <div className="bg-white rounded-2xl w-full max-w-lg max-h-[60vh] overflow-y-auto p-4 sm:p-6 relative">
        <button onClick={props.onClose} className="absolute right-4 top-4" aria-label="Close">
          <X />
        </button>
        <Component {...props} />
      </div>
    </div>
  );
};

export default FilterModal;
